import TabsNavigations from './TabsNavigations'

export default TabsNavigations
